<template>
  <div class="reward" style="min-height:285px">
    <h3>{{ reward.price }}</h3>
    <h4>{{ reward.title }}</h4>
    <p>{{ reward.description | truncate(40) }}</p>
    <div v-if="showButtons">
      <!-- Button trigger modal -->
      <button @click="showEditForm = true" type="button" :class="'btn btn-default btn-lg button-wide-' + buttonColor">
        {{ $t("edit") }}
      </button>
      <!-- Button trigger modal -->
      <button @click="showDeleteModal = true" type="button" :class="'btn btn-default btn-lg button-wide-' + buttonColor">
        {{ $t("remove") }}
      </button>
    </div>

    <!-- Remove reward modal -->
    <remove-reward v-if="showDeleteModal" :close="closeModal" :rewards='rewards' :reward='reward'></remove-reward>
    <reward-form v-if="showEditForm" :close="closeForm" :rewards='rewards' :reward='reward' :action="'edit'" :buttonColor="buttonColor" :currency="currency"></reward-form>

  </div>
</template>

<script>
import RemoveReward from '@/components/Reward/Remove';
import RewardForm from '@/components/Reward/Form';

export default {
  data() {
    return {
      showDeleteModal: false,
      showEditForm: false,
    };
  },
  methods: {
    closeModal() {
      this.showDeleteModal = false;
    },
    closeForm() {
      this.showEditForm = false;
    },
  },
  props: ['reward', 'rewards', 'buttonColor', 'currency', 'showButtons'],
  components: { RemoveReward, RewardForm },
};
</script>



// WEBPACK FOOTER //
// Tile.vue?5e0cabb2